import { Navigate, useParams } from "react-router-dom";

// A link to a review's conversation from before reviews moved into the conversations.
export const ReviewRedirect = () => {
  const { runId } = useParams();
  return <Navigate to={`../learning-agents/conversations/${runId ?? ""}`} replace />;
};
